import { CSSProperties, FunctionComponent } from 'react'

import CurrencyLabel from 'components/util/currencyLabel'
import { TransferIndicators } from '../transferIndicators'
import { TransferStatus } from '../types'
import { STATUS_CARD_ORDER, TRANSFER_STATUS_META } from '../transferStatus'
import transfersCss from '../styles.module.scss'

type StatusCardsProps = {
  indicators: TransferIndicators
  selected: TransferStatus
  onSelect: (status: TransferStatus) => void
}

const StatusCards: FunctionComponent<StatusCardsProps> = ({
  indicators,
  selected,
  onSelect,
}) => (
  <section className={transfersCss.statusGrid} aria-label="Totais por status">
    {STATUS_CARD_ORDER.map((status) => {
      const meta = TRANSFER_STATUS_META[status]
      const total = indicators.getTotalByStatus(status)
      const disabled = total <= 0

      return (
        <button
          key={status}
          type="button"
          className={`card ${transfersCss.statusCard}`}
          style={{ '--accent': meta.color } as CSSProperties}
          aria-pressed={selected === status}
          disabled={disabled}
          onClick={() => onSelect(status)}
        >
          <span className={transfersCss.statusCardLabel}>
            <span
              className={transfersCss.statusDot}
              style={{ background: meta.color }}
            />
            {meta.title}
          </span>
          <span className={transfersCss.statusCardValue}>
            <CurrencyLabel>{total}</CurrencyLabel>
          </span>
          <span
            className={`line-clamp-2 ${transfersCss.statusCardDesc}`}
            aria-hidden={!meta.description}
          >
            {meta.description}
          </span>
        </button>
      )
    })}
  </section>
)

export default StatusCards
